// CDN Server
import _FileApi from "./Cdn/File.api";
import _CsvApi from "./Cdn/Csv.api";
import _ExcelApi from "./Cdn/Excel.api";
import _ImageApi from "./Cdn/Image.api";
import _GatewayApi from "./Gateway/Gateway.api";

// Auth Server
import _GroupApi from "./Auth/Group.api";
import _OauthApi from "./Auth/Oauth.api";
import _PermissionApi from "./Auth/Permission.api";
import _ResourceApi from "./Auth/Resource.api";
import _RoleApi from "./Auth/Role.api";
import _ScopeApi from "./Auth/Scope.api";
import _UserApi from "./Auth/User.api";
import _UserFilterApi from "./Auth/UserFilter.api";
import _OrganizationApi from "./Auth/Organization.api";
import _OrganogramApi from "./Auth/Organogram.api";
import _EmployeeApi from "./Auth/Employee.api";
import _RequestAccessApi from "./Auth/RequestAccess.api";
import _OrganogramDesignationApi from "./Auth/OrganogramDesignation.api";
import _OAuthClientApi from "./Auth/OAuthClient.api";
import _UserNidDetailApi from "./Auth/UserNidDetail.api";
import _ModuleApi from "./Auth/Module.api";
import _UserRequestApi from "./Auth/UserRequest.api";
import _EmployeeReleaseApi from "./Auth/EmployeeRelease.api";
import _EmployeeJoinApi from "./Auth/EmployeeJoin.api";

// Core Server
import _LookupApi from "./Core/Lookup.api";
import _LocationApi from "./Core/Location.api";
import _LocationBlockApi from "./Core/LocationBlock.api";
import _ComponentApi from "./Core/Component.api";
import _PostApi from "./Core/Post.api";
import _OptionApi from "./Core/Option.api";
import _TemplateApi from "./Core/Template.api";
import _HelpManualApi from "./Core/HelpManual.api";
import _HelpFaqApi from "./Core/HelpFaq.api";
import _FakeApi from "./Core/Fake.api";
import _OrganizationCategoryApi from "./Core/OrganizationCategory.api";
import _DepartmentApi from "./Core/Department.api";
import _ExamApi from "./Core/Exam.api";
import _FinancialYearApi from "./Core/FinancialYear.api";
import _EnumApi from "./Core/Enum.api";
import _BankApi from "./Core/Bank.api";
import _BankBranchApi from "./Core/BankBranch.api";
import _OrganizationBankAccountApi from "./Core/OrganizationBankAccount.api";
import _DesignationApi from "./Auth/Designation.api";
import _DepartmentSubjectApi from "./Core/DepartmentSubject.api";
import _InstituteOrganizationApi from "./Core/InstituteOrganization.api";
import _AutomationRuleApi from "./Core/AutomationRule.api";
import _WorkflowApprovalApi from "./Core/WorkflowApproval.api";
import _WorkflowStepApi from "./Core/WorkflowStep.api";
import _WorkflowTransitionApi from "./Core/WorkflowTransition.api";
import _NoticeApi from "./Core/Notice.api";
import _OwnerShipTypeApi from "./Core/OwnerShipType.api";
import _PaymentGatewayApi from "./Core/PaymentGateway.api";
import _PaymentApi from "./Core/Payment.api";
import _PaymentHistoryApi from "./Core/PaymentHistory.api";
import _PaymentIpnLogApi from "./Core/PaymentIpnLog.api";
import _PaymentRefundApi from "./Core/PaymentRefund.api";
import _PaymentEchallanApi from "./Core/PaymentEchallan.api";
import _PaymentServiceWiseRegistryApi from "./Core/PaymentServiceWiseRegistry.api";
import _UnitApi from "./Core/Unit.api";
import _ProjectApi from "./Core/Project.api";
import _ProjectComponentApi from "./Core/ProjectComponent.api";
import _ExchangeRateApi from "./Core/ExchangeRate.api";
import _TermConditionApi from "./Core/TermCondition.api";
import _DoptorServiceApi from "./Core/DoptorService.api";
import _EnothiServiceWiseRegistryApi from "./Core/EnothiServiceWiseRegistry.api";
import _WebhookApi from "./Core/Webhook.api";
import _TemplateVariableApi from "./Core/TemplateVariable.api";
import _CoreAdminDashboardApi from "./Core/CoreAdminDashboard.api";
import _AttachmentTypeApi from "./Core/AttachmentType.api";
import _ComponentModuleFeatureApi from "./Core/ComponentModuleFeature.api";

// QIS Server
import _CropApi from "./QIS/Crop.api";
import _MessagingApi from "./QIS/Messaging.api";
import _VarietyCategoryApi from "./QIS/VarietyCategory.api";
import _UserLevelGroupApi from "./QIS/UserLevelGroup.api";
import _PreferenceApi from "./QIS/Preference.api";
import _SeasonApi from "./QIS/Season.api";
import _CropLandAreaApi from "./QIS/CropLandArea.api";
import _CropTypeApi from "./Core/CropType.api";
import _CropVarietyTypeApi from "./Core/CropVarietyType.api";
import _CropVarietyApi from "./QIS/CropVariety.api";
import _CropRequestApi from "./QIS/CropRequest.api";
import _VarietyRequestApi from "./QIS/VarietyRequest.api";
import _RainfallApi from "./QIS/Rainfall.api";
import _CropTargetApi from "./QIS/CropTarget.api";
import _CropSeedDemandApi from "./QIS/CropSeedDemand.api";
import _SeedPreservationApi from "./QIS/SeedPreservation.api";
import _SeedDealerProductionApi from "./QIS/SeedDealerProduction.api";
import _CropProductionApi from "./QIS/CropProduction.api";
import _CropStageApi from "./QIS/CropStage.api";
import _DisasterApi from "./QIS/Disaster.api";
import _CompilationSeedbedTargetApi from "./QIS/CompilationSeedbedTarget.api";
import _CompilationSeedbedProductionApi from "./QIS/CompilationSeedbedProduction.api";
import _CompilationCultivationProductionApi from "./QIS/CompilationCultivationProduction.api";
import _CompilationCultivationTargetApi from "./QIS/CompilationCultivationTarget.api";
import _CompilationSeedDemandApi from "./QIS/CompilationSeedDemand.api";
import _CompilationSeedPreservationApi from "./QIS/CompilationSeedPreservation.api";
import _CompilationStageApi from "./QIS/CompilationStage.api";
import _CompilationDemandApi from "./QIS/CompilationDemand.api";
import _CropCompilationApi from "./QIS/CropCompilation.api";
import _FertilizerApi from "./QIS/Fertilizer.api";
import _FarmarApi from "./QIS/Farmar.api";
import _PFSPositionApi from "./QIS/PFSPosition.api";
import _WarehouseApi from "./QIS/Warehouse.api";
import _CropsWingReportApi from "./QIS/CropsWingReportApi.api";
import _QisReportApi from "./QIS/QisReportApi.api";
import _DealerDistributorRetailerApi from "./QIS/DealerDistributorRetailer.api";
import _DealerWiseFertilizerDistributionByUpazilaApi from "./QIS/DealerWiseFertilizerDistributionByUpazila.api";

import _FertilizerCollectionProcessApi from "./QIS/FertilizerCollectionProcess.api";
import _FertilizerDemandApi from "./QIS/FertilizerDemand.api";
import _FertilizerAllocationApi from "./QIS/FertilizerAllocation.api";
import _FertilizerStockApi from "./QIS/FertilizerStock.api";
import _FertilizerSampleTestingApi from "./QIS/FertilizerSampleTesting.api";
import _FertilizerCaseInfoApi from "./QIS/FertilizerCaseInfo.api";
import _SampleTestingFundAllocationApi from "./QIS/SampleTestingFundAllocation.api";
import _FertilizerPurchaseApi from "./QIS/FertilizerPurchase.api";
import _NurseryRegistrationApi from "./QIS/NurseryRegistration.api";
import _NurseryRegistrationInformationApi from "./QIS/NurseryRegistrationInformation.api";
import _NurseryRegistrationFeeApi from "./QIS/NurseryRegistrationFee.api";
import _NurseryRegistrationFeeTypeApi from "./QIS/NurseryRegistrationFeeType.api";
import _FruitGardenApi from "./QIS/FruitGarden.api";
import _CompilationLockApi from "./QIS/CompilationLock.api";
import _ImportFertilizerApi from "./QIS/ImportFertilizer.api";
import _ProgressTrackerAnnualTargetApi from "./PMIS/ProgressTrackerAnnualTarget.api";
import _DlrProgressApi from "./PMIS/DlrProgress.api";
import _ActivityProgressApi from "./PMIS/ActivityProgress.api";
import _PmisTrainingApi from "./QIS/PmisTraining.api";
import _TrainingTitleApi from "./QIS/TrainingTitle.api";
import _PmisSoeApi from "./QIS/PmisSoe.api";
import _PesticideApi from "./QIS/Pesticide.api";
import _DiseaseApi from "./QIS/Disease.api";
import _EquipmentApi from "./QIS/Equipment.api";
import _NutritionalDeficiencyApi from "./QIS/NutritionalDeficiency.api";
import _IrrigationEquipmentDemandApi from "./QIS/IrrigationEquipmentDemand.api";
import _IrrigationEquipmentSummaryApi from "./QIS/IrrigationEquipmentSummary.api";
import _IrrigatedLandSummaryApi from "./QIS/IrrigatedLandSummary.api";
import _EquipmentTypeApi from "./QIS/EquipmetType.api";
import _IrrigationEquipmentMonthWiseFuelDemandApi from "./QIS/IrrigationEquipmentMonthWiseFuelDemand.api";
import _CompilationIrrigationEquipmentDemandApi from "./QIS/CompilationIrrigationEquipmentDemand.api";
import _PesticideBrandApi from "./QIS/PesticideBrand.api";
import _MonitoringDashboardApi from "./QIS/MonitoringDashboard.api";
import _PesticideFertilizerApi from "./QIS/PesticideFertilizer.api";
import _PesticidePestApi from "./QIS/PesticidePest.api";
import _TrainingCategoryApi from "./QIS/TrainingCategory.api";

import _ProcurementMethodApi from "./QIS/ProcurementMethod.api";
import _ApprovingAuthorityApi from "./QIS/ApprovingAuthority.api";
import _ProcuringEntityApi from "./QIS/ProcuringEntity.api";
import _DppPackageApi from "./QIS/DppPackage.api";
import _TendererInformationApi from "./QIS/TendererInformation.api";
import _CommitteeInformationApi from "./QIS/CommitteeInformation.api";
import _PackageInformationApi from "./QIS/PackageInformation.api";
import _ProcurementPlanApi from "./QIS/ProcurementPlan.api";
import _ProcurementRecordApi from "./QIS/ProcurementRecord.api";
import _ProcurementProgressApi from "./QIS/ProcurementProgress.api";
import _TechnologyApi from "./QIS/Technology.api";
import _IncentivePackageApi from "./QIS/IncentivePackage.api";
import _IncentiveDistributionApi from "./QIS/IncentiveDistribution.api";
import _IncentiveTypeApi from "./QIS/IncentiveType.api";
import _IncentiveAllocationDistrictApi from "./QIS/IncentiveAllocationDistrict.api";
import _IncentiveAllocationUpazilaApi from "./QIS/IncentiveAllocationUpazila.api";
import _IncentiveAllocationBlockApi from "./QIS/IncentiveAllocationBlock.api";
import _SeedlingApi from "./QIS/Seedling.api";
import _TreePlantationPackageApi from "./QIS/TreePlantationPackage.api";
import _TreePlantationDistributionApi from "./QIS/TreePlantationDistribution.api";

// PMIS SERVER
import _PmisReportApi from "./PMIS/PmisReportApi.api";
import _DlrTargetApi from "./PMIS/DlrTarget.api";
import _DemonstrationNameApi from "./PMIS/DemonstrationName.api";
import _DlrAnnualTargetApi from "./PMIS/DlrAnnualTarget.api";
import _PfsTargetApi from "./QIS/PfsTarget.api";
import _NonRiceSeedCultivationApi from "./PMIS/NonRiceSeedCultivation.api";
import _FruitsVegetablesGapCertificationApi from "./PMIS/FruitsVegetablesGapCertification.api";
import _DemoDemandApi from "./PMIS/DemoDemand.api";
import _DemoTargetApi from "./PMIS/DemoTarget.api";
import _DemonstrationApi from "./PMIS/Demonstration.api";
import _NewRiceVarietyCultivationInfoApi from "./PMIS/NewRiceVarietyCultivationInfo.api";
import _OtherCropSeedProductionApi from "./PMIS/OtherCropSeedProduction.api";
import _EfficientIrrigationApi from "./PMIS/EfficientIrrigation.api";
import _RiceSeedProductionApi from "./PMIS/RiceSeedProduction.api";
import _PartnerFieldSchoolApi from "./PMIS/PartnerFieldSchool.api";
import _DuplicateMergingPmisApi from "./PMIS/DuplicateMergingPmis.api";

// FMIS SERVER

import _BudgetApi from "./FMIS/Budget.api";
import _AdditionalBudgetApi from "./FMIS/AdditionalBudget.api";
import _BudgetNonTaxRevenueApi from "./FMIS/BudgetNonTaxRevenue.api";
import _AllocationApi from "./FMIS/Allocation.api";
import _BudgetApprovalApi from "./FMIS/BudgetApproval.api";
import _ExpenditureApi from "./FMIS/Expenditure.api";
import _EconomicCodeApi from "./FMIS/EconomicCode.api";
import _QuarterApi from "./FMIS/Quarter.api";
import _NonTaxRevenueApi from "./FMIS/NonTaxRevenue.api";
import _FmisReportApi from "./FMIS/FmisReport.api";
import _MaterializedViewApi from "./FMIS/MaterializedView.api";

// CMS Server
import _PageApi from "./Cms/Page.api";
import _BlocksApi from "./Cms/Blocks.api";
import _MenuApi from "./Cms/Menu.api";
import _MediaApi from "./Cms/Media.api";
import _CategoriesApi from "./Cms/Categories.api";

// Util Server
import _ActivityLogApi from "./Util/ActivityLog.api";
import _AuditLogApi from "./Util/AuditLog.api";
import _ErrorLogApi from "./Util/ErrorLog.api";
import _IntegrationLogApi from "./Util/IntegrationLog.api";
import _ApiRequestLogApi from "./Util/ApiRequestLog.api";
import _LoginActivityLogApi from "./Util/LoginActivityLog.api";
import _WebsocketApi from "./Util/Websocket.api";
import _NotificationApi from "./Util/Notification.api";

// CND Server
export const FileApi = new _FileApi();
export const CsvApi = new _CsvApi();
export const ExcelApi = new _ExcelApi();
export const ImageApi = new _ImageApi();
export const GatewayApi = new _GatewayApi();

// Auth Server
export const GroupApi = new _GroupApi();
export const OauthApi = new _OauthApi();
export const PermissionApi = new _PermissionApi();
export const ResourceApi = new _ResourceApi();
export const RoleApi = new _RoleApi();
export const ScopeApi = new _ScopeApi();
export const UserApi = new _UserApi();
export const UserFilterApi = new _UserFilterApi();
export const OrganizationApi = new _OrganizationApi();
export const OrganogramApi = new _OrganogramApi();
export const EmployeeApi = new _EmployeeApi();
export const RequestAccessApi = new _RequestAccessApi();

export const OrganogramDesignationApi = new _OrganogramDesignationApi();
export const OAuthClientApi = new _OAuthClientApi();
export const UserNidDetailApi = new _UserNidDetailApi();
export const ModuleApi = new _ModuleApi();
export const UserRequestApi = new _UserRequestApi();
export const EmployeeReleaseApi = new _EmployeeReleaseApi();
export const EmployeeJoinApi = new _EmployeeJoinApi();

// Core Server
export const FakeApi = new _FakeApi();
export const NotificationApi = new _NotificationApi();
export const LookupApi = new _LookupApi();
export const LocationApi = new _LocationApi();
export const LocationBlockApi = new _LocationBlockApi();
export const ComponentApi = new _ComponentApi();
export const PostApi = new _PostApi();
export const OptionApi = new _OptionApi();
export const TemplateApi = new _TemplateApi();
export const HelpManualApi = new _HelpManualApi();
export const HelpFaqApi = new _HelpFaqApi();
export const OrganizationCategoryApi = new _OrganizationCategoryApi();
export const DepartmentApi = new _DepartmentApi();
export const ExamApi = new _ExamApi();
export const FinancialYearApi = new _FinancialYearApi();
export const EnumApi = new _EnumApi();
export const BankApi = new _BankApi();
export const BankBranchApi = new _BankBranchApi();
export const OrganizationBankAccountApi = new _OrganizationBankAccountApi();
export const DesignationApi = new _DesignationApi();
export const DepartmentSubjectApi = new _DepartmentSubjectApi();
export const InstituteOrganizationApi = new _InstituteOrganizationApi();
export const AutomationRuleApi = new _AutomationRuleApi();
export const WorkflowApprovalApi = new _WorkflowApprovalApi();
export const WorkflowStepApi = new _WorkflowStepApi();
export const WorkflowTransitionApi = new _WorkflowTransitionApi();
export const NoticeApi = new _NoticeApi();
export const OwnerShipTypeApi = new _OwnerShipTypeApi();
export const PaymentGatewayApi = new _PaymentGatewayApi();
export const PaymentApi = new _PaymentApi();
export const PaymentHistoryApi = new _PaymentHistoryApi();
export const PaymentIpnLogApi = new _PaymentIpnLogApi();
export const PaymentRefundApi = new _PaymentRefundApi();
export const PaymentEchallanApi = new _PaymentEchallanApi();
export const PaymentServiceWiseRegistryApi = new _PaymentServiceWiseRegistryApi();
export const UnitApi = new _UnitApi();
export const ProjectApi = new _ProjectApi();
export const ProjectComponentApi = new _ProjectComponentApi();
export const ExchangeRateApi = new _ExchangeRateApi();
export const TermConditionApi = new _TermConditionApi();
export const DoptorServiceApi = new _DoptorServiceApi();
export const EnothiServiceWiseRegistryApi = new _EnothiServiceWiseRegistryApi();
export const WebhookApi = new _WebhookApi();
export const TemplateVariableApi = new _TemplateVariableApi();
export const CoreAdminDashboardApi = new _CoreAdminDashboardApi();
export const AttachmentTypeApi = new _AttachmentTypeApi();
export const ComponentModuleFeatureApi = new _ComponentModuleFeatureApi();

// QIS Server
export const CropTypeApi = new _CropTypeApi();
export const UserLevelGroupApi = new _UserLevelGroupApi();
export const CropApi = new _CropApi();
export const MessagingApi = new _MessagingApi();
export const VarietyCategoryApi = new _VarietyCategoryApi();
export const DisasterApi = new _DisasterApi();
export const PreferenceApi = new _PreferenceApi();
export const SeasonApi = new _SeasonApi();
export const CropLandAreaApi = new _CropLandAreaApi();
export const CropVarietyTypeApi = new _CropVarietyTypeApi();
export const CropVarietyApi = new _CropVarietyApi();
export const CropRequestApi = new _CropRequestApi();
export const VarietyRequestApi = new _VarietyRequestApi();
export const RainfallApi = new _RainfallApi();
export const CropTargetApi = new _CropTargetApi();
export const CropSeedDemandApi = new _CropSeedDemandApi();
export const SeedPreservationApi = new _SeedPreservationApi();
export const SeedDealerProductionApi = new _SeedDealerProductionApi();
export const CropProductionApi = new _CropProductionApi();
export const CropStageApi = new _CropStageApi();
export const CompilationSeedbedTargetApi = new _CompilationSeedbedTargetApi();
export const CompilationSeedbedProductionApi = new _CompilationSeedbedProductionApi();
export const CompilationCultivationProductionApi = new _CompilationCultivationProductionApi();
export const CompilationDemandApi = new _CompilationDemandApi();
export const CropTargetCompilationApi = new _CompilationSeedbedTargetApi();
export const CompilationCultivationTargetApi = new _CompilationCultivationTargetApi();
export const CompilationSeedDemandApi = new _CompilationSeedDemandApi();
export const CompilationSeedPreservationApi = new _CompilationSeedPreservationApi();
export const CompilationStageApi = new _CompilationStageApi();
export const CropCompilationApi = new _CropCompilationApi();
export const FertilizerApi = new _FertilizerApi();
export const PesticideFertilizerApi = new _PesticideFertilizerApi();
export const PesticidePestApi = new _PesticidePestApi();
export const FarmarApi = new _FarmarApi();
export const PFSPositionApi = new _PFSPositionApi();
export const WarehouseApi = new _WarehouseApi();
export const CropsWingReportApi = new _CropsWingReportApi();
export const QisReportApi = new _QisReportApi();
export const DealerDistributorRetailerApi = new _DealerDistributorRetailerApi();
export const DealerWiseFertilizerDistributionByUpazilaApi = new _DealerWiseFertilizerDistributionByUpazilaApi();
export const FertilizerCollectionProcessApi = new _FertilizerCollectionProcessApi();
export const FertilizerDemandApi = new _FertilizerDemandApi();
export const FertilizerAllocationApi = new _FertilizerAllocationApi();
export const FertilizerStockApi = new _FertilizerStockApi();
export const FertilizerSampleTestingApi = new _FertilizerSampleTestingApi();
export const FertilizerCaseInfoApi = new _FertilizerCaseInfoApi();
export const SampleTestingFundAllocationApi = new _SampleTestingFundAllocationApi();
export const FertilizerPurchaseApi = new _FertilizerPurchaseApi();
export const NurseryRegistrationApi = new _NurseryRegistrationApi();
export const NurseryRegistrationInformationApi = new _NurseryRegistrationInformationApi();
export const NurseryRegistrationFeeApi = new _NurseryRegistrationFeeApi();
export const NurseryRegistrationFeeTypeApi = new _NurseryRegistrationFeeTypeApi();
export const FruitGardenApi = new _FruitGardenApi();
export const CompilationLockApi = new _CompilationLockApi();
export const ImportFertilizerApi = new _ImportFertilizerApi();
export const ProgressTrackerAnnualTargetApi = new _ProgressTrackerAnnualTargetApi();
export const DlrProgressApi = new _DlrProgressApi();
export const ActivityProgressApi = new _ActivityProgressApi();
export const PmisTrainingApi = new _PmisTrainingApi();
export const PmisSoeApi = new _PmisSoeApi();
export const PesticideApi = new _PesticideApi();
export const DiseaseApi = new _DiseaseApi();
export const NutritionalDeficiencyApi = new _NutritionalDeficiencyApi();
export const EquipmentApi = new _EquipmentApi();
export const IrrigationEquipmentDemandApi = new _IrrigationEquipmentDemandApi();
export const IrrigationEquipmentSummaryApi = new _IrrigationEquipmentSummaryApi();
export const IrrigatedLandSummaryApi = new _IrrigatedLandSummaryApi();
export const EquipmentTypeApi = new _EquipmentTypeApi();
export const IrrigationEquipmentMonthWiseFuelDemandApi = new _IrrigationEquipmentMonthWiseFuelDemandApi();
export const CompilationIrrigationEquipmentDemandApi = new _CompilationIrrigationEquipmentDemandApi();
export const PesticideBrandApi = new _PesticideBrandApi();
export const MonitoringDashboardApi = new _MonitoringDashboardApi();
export const TrainingTitleApi = new _TrainingTitleApi();
export const TrainingCategoryApi = new _TrainingCategoryApi();
export const ProcurementMethodApi = new _ProcurementMethodApi();
export const ApprovingAuthorityApi = new _ApprovingAuthorityApi();
export const ProcuringEntityApi = new _ProcuringEntityApi();
export const DppPackageApi = new _DppPackageApi();
export const TendererInformationApi = new _TendererInformationApi();
export const CommitteeInformationApi = new _CommitteeInformationApi();
export const PackageInformationApi = new _PackageInformationApi();
export const ProcurementPlanApi = new _ProcurementPlanApi();
export const ProcurementRecordApi = new _ProcurementRecordApi();
export const ProcurementProgressApi = new _ProcurementProgressApi();
export const TechnologyApi = new _TechnologyApi();
export const IncentivePackageApi = new _IncentivePackageApi();
export const IncentiveDistributionApi = new _IncentiveDistributionApi();
export const IncentiveTypeApi = new _IncentiveTypeApi();
export const IncentiveAllocationDistrictApi = new _IncentiveAllocationDistrictApi();
export const IncentiveAllocationUpazilaApi = new _IncentiveAllocationUpazilaApi();
export const IncentiveAllocationBlockApi = new _IncentiveAllocationBlockApi();
export const SeedlingApi = new _SeedlingApi();
export const TreePlantationPackageApi = new _TreePlantationPackageApi();
export const TreePlantationDistributionApi = new _TreePlantationDistributionApi();

// FMIS SERVER
export const EconomicCodeApi = new _EconomicCodeApi();
export const BudgetApi = new _BudgetApi();
export const AdditionalBudgetApi = new _AdditionalBudgetApi();
export const BudgetNonTaxRevenueApi = new _BudgetNonTaxRevenueApi();
export const AllocationApi = new _AllocationApi();
export const BudgetApprovalApi = new _BudgetApprovalApi();
export const ExpenditureApi = new _ExpenditureApi();
export const QuarterApi = new _QuarterApi();
export const NonTaxRevenueApi = new _NonTaxRevenueApi();
export const FmisReportApi = new _FmisReportApi();
export const MaterializedViewApi = new _MaterializedViewApi();

// PMIS SERVER
export const PmisReportApi = new _PmisReportApi();
export const PfsTargetApi = new _PfsTargetApi();
export const DlrTargetApi = new _DlrTargetApi();
export const DlrAnnualTargetApi = new _DlrAnnualTargetApi();
export const NonRiceSeedCultivationApi = new _NonRiceSeedCultivationApi();
export const FruitsVegetablesGapCertificationApi = new _FruitsVegetablesGapCertificationApi();
export const DemonstrationApi = new _DemonstrationApi();
export const DemoDemandApi = new _DemoDemandApi();
export const DemoTargetApi = new _DemoTargetApi();
export const NewRiceVarietyCultivationInfoApi = new _NewRiceVarietyCultivationInfoApi();
export const OtherCropSeedProductionApi = new _OtherCropSeedProductionApi();
export const EfficientIrrigationApi = new _EfficientIrrigationApi();
export const RiceSeedProductionApi = new _RiceSeedProductionApi();
export const PartnerFieldSchoolApi = new _PartnerFieldSchoolApi();
export const DemonstrationNameApi = new _DemonstrationNameApi();
export const DuplicateMergingPmisApi = new _DuplicateMergingPmisApi();

// CMS Server
export const PageApi = new _PageApi();
export const BlocksApi = new _BlocksApi();
export const MenuApi = new _MenuApi();
export const MediaApi = new _MediaApi();
export const CategoriesApi = new _CategoriesApi();

// Util
export const ActivityLogApi = new _ActivityLogApi();
export const AuditLogApi = new _AuditLogApi();
export const ErrorLogApi = new _ErrorLogApi();
export const IntegrationLogApi = new _IntegrationLogApi();
export const ApiRequestLogApi = new _ApiRequestLogApi();
export const LoginActivityLogApi = new _LoginActivityLogApi();
export const WebsocketApi = new _WebsocketApi();
